import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

let _cache = null;
let _inflight = null;

export const fetchSiteContent = async () => {
  if (_cache) return _cache;
  if (!_inflight) {
    _inflight = axios.get(`${API}/site-content`).then(({ data }) => { _cache = data; return data; })
      .catch(() => ({})).finally(() => { _inflight = null; });
  }
  return _inflight;
};

export const clearSiteContentCache = () => { _cache = null; };

export const siteImageUrl = (val) => {
  if (!val) return "";
  if (val.startsWith("http") || val.startsWith("/api/")) {
    return val.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${val}` : val;
  }
  return val;
};

export const useSiteContent = () => {
  const [content, setContent] = useState(_cache);
  useEffect(() => { let on = true; fetchSiteContent().then((d) => { if (on) setContent(d); }); return () => { on = false; }; }, []);
  return content;
};
